/**
 * Collectable skins: found as loot during a match, kept forever in the player's collection
 * (never swapped out), and used as the base under the player's drawn emblem.
 */
export const COLLECTIBLE_SKINS: readonly string[] = [
    "bloodlust", "red_tomato", "greenhorn", "blue_blood", "silver_lining", "pot_o_gold", "twilight_zone", "bubblegum",
    "sunrise", "sunset", "stratosphere", "mango", "snow_cone", "aquatic", "floral", "sunny", "volcanic", "solar_flare",
    "beacon", "wave_jumpsuit", "toadstool", "full_moon", "swiss_cheese", "target_practice", "zebra", "tiger", "bee",
    "armadillo", "printer", "distant_shores", "celestial", "fireball", "blueberry_smoothie"
];

const set = new Set(COLLECTIBLE_SKINS);
export const isCollectibleSkin = (id: string): boolean => set.has(id);
